"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.debounce = debounce;
exports.gatherClasses = gatherClasses;
exports.gatherConditionalProps = gatherConditionalProps;
exports.gatherStyles = gatherStyles;
exports.generateId = generateId;
exports.getPercentageValue = getPercentageValue;
exports.getValueInPx = getValueInPx;
exports.hasProperty = hasProperty;
exports.isDescendant = isDescendant;
exports.isEmpty = isEmpty;
exports.isFunction = isFunction;
exports.isMobileBrowser = isMobileBrowser;
exports.isObject = isObject;
exports.isSafariBrowser = isSafariBrowser;
exports.isString = isString;
exports.requiredIf = requiredIf;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _reverse = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reverse"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/ends-with"));

var _isEmpty = _interopRequireDefault(require("lodash-es/isEmpty"));

function hasProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
/**
 * This function will gather all the classes either provided to the component through props
 * or the additional classes required at the component level
 * @param {*} props props passed to the component.
 *    props should be an object containing a property 'className'
 * @param {...string} extraClasses classes other than the passed through props.
 *    these should be a comma separated list of class names (string)
 */


function gatherClasses(props) {
  var classes = [];

  if (props && props.className) {
    classes.push(props.className);
  }

  for (var _len = arguments.length, extraClasses = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    extraClasses[_key - 1] = arguments[_key];
  }

  if (extraClasses && extraClasses.length > 0) {
    (0, _forEach["default"])(extraClasses).call(extraClasses, function (className) {
      if (className && className !== "") {
        classes.push(className);
      }
    });
  }

  return classes.length > 0 ? classes.join(" ") : null;
}
/**
 * There are couple of situations where the property might be provided or not
 * In such case this will be a common location to collect such conditional properties
 * @param {*} props
 *    props those are passes to the component
 * @param {...string} conditionalProps
 *    names of the props the component is interested in
 */


function gatherConditionalProps(props) {
  var properties = {};

  for (var _len2 = arguments.length, conditionalProps = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    conditionalProps[_key2 - 1] = arguments[_key2];
  }

  if (props && conditionalProps.length > 0) {
    (0, _forEach["default"])(conditionalProps).call(conditionalProps, function (prop) {
      if (hasProperty(props, prop)) {
        properties[prop] = props[prop];
      }
    });
  }

  return properties;
}
/**
 * This utility function will gather given conditional styles from props
 * and if at least one style is found, then will return style object
 */


function gatherStyles(props) {
  var styles = {};

  for (var _len3 = arguments.length, conditionalStyles = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    conditionalStyles[_key3 - 1] = arguments[_key3];
  }

  if (props && conditionalStyles.length > 0) {
    (0, _forEach["default"])(conditionalStyles).call(conditionalStyles, function (prop) {
      if (hasProperty(props, prop)) {
        styles[prop] = props[prop];
      }
    });
  }

  return (0, _keys["default"])(styles).length === 0 ? null : {
    style: styles
  };
}
/**
 * This utility function should be used to see if the given prop is actually a function or not.
 * @param {any} func
 *    the prop to be tested if it is a function
 */


function isFunction(func) {
  return func && typeof func === "function";
}
/**
 * This utility function should be used to see if the given prop is actually a string or not.
 * @param {any} str
 *    the prop to be tested if it is a string
 */


function isString(str) {
  return str && typeof str === "string";
}
/**
 * Utility function to check if given item is real javascript object or not
 *
 * @param {any} obj
 */


function isObject(obj) {
  return obj && (0, _typeof2["default"])(obj) === "object" && !isFunction(obj);
}
/**
 * A utility function to generate dynamic id
 */


function generateId() {
  var _context;

  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var length = 8;

  var _getRandomInt = function _getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  var parts = (0, _reverse["default"])(_context = (0, _now["default"])().toString().split("")).call(_context);
  var id = "";

  for (var i = 0; i < length; ++i) {
    var index = _getRandomInt(0, parts.length - 1);

    id += parts[index];
  }

  return prefix + id + suffix;
}
/**
 * This function will calculate the percentage out of given total and value
 */


function getPercentageValue() {
  var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Number(value) * 100 / Number(total);
}
/**
 * A utility function for conditional required prop types
 */


function requiredIf(type, condition) {
  return function cb(props, propName, componentName) {
    if (typeof type !== "function") {
      return new Error("Invalid react-required-if prop type supplied to ".concat(componentName, ". Validation failed."));
    }

    if (typeof condition !== "function") {
      return new Error("Invalid react-required-if condition supplied to ".concat(componentName, ". Validation failed."));
    }

    var test = condition(props) ? type.isRequired : type; // eslint-disable-next-line prefer-rest-params

    return test.apply(this, arguments);
  };
}

function isDescendant(parent, child) {
  var node = child.parentNode;

  while (node != null) {
    if (node === parent) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

function isEmpty(value) {
  var type = (0, _typeof2["default"])(value);

  if (type === "string" || type === "boolean" || type === "number") {
    return !value || value === "";
  }

  if (value === null || typeof value === "undefined") {
    return true;
  }

  if (!(value instanceof Date)) {
    return (0, _isEmpty["default"])(value);
  }

  return !value;
}

function debounce(func, wait, immediate) {
  var _arguments = arguments,
      _this = this;

  var timeout;

  var debounced = function debounced() {
    var context = _this; // eslint-disable-next-line prefer-rest-params

    var args = _arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = (0, _setTimeout2["default"])(later, wait);
    if (callNow) func.apply(context, args);
  };

  debounced.cancel = function cb() {
    if (timeout !== null && typeof timeout === "number") {
      clearTimeout(timeout);
    }
  };

  return debounced;
}

function isMobileBrowser() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function getValueInPx(value) {
  var _context2;

  return (0, _endsWith["default"])(_context2 = String(value)).call(_context2, "px") ? value : "".concat(value, "px");
}

function isSafariBrowser() {
  return navigator.vendor.match(/apple/i) && !navigator.userAgent.match(/crios/i) && !navigator.userAgent.match(/fxios/i);
}